import ChangeUserImageModal from './ChangeUserImageModal'

export default ChangeUserImageModal
